import React, { Component } from 'react';
import Auth from '../containers/Auth';
// import Auth from '@app-masters/react-auth-container';
import LoginView from '../views/AuthViews/loginView';
import SignupView from '../views/AuthViews/signupView';
import ResetPasswordView from '../views/AuthViews/resetPasswordView';

class PublicRoutes extends Component {
    render () {
        console.log(this.props);
        return (
            <Auth login={<LoginView />} signup={<SignupView />} resetPassword={<ResetPasswordView />} />
        );
    }
}

export default PublicRoutes;



// WEBPACK FOOTER //
// ./src/routes/publicRoutes.js